import React from 'react';
import '../Box/Box.css';



function Box(props) {
  return (
    <div className='box-div'>
      <div className='icon'>
        <div className='blur' id={props.bgcolor}></div>
        <img className='img' src='./images/icons/eye-glasses.png' alt=''/>
      </div>
      <div className='text'>
        <span>{props.span1}</span>
        <span>{props.span2}</span>
      </div>
    </div>
  )
}

export default Box;
